export default class RangeSliderController extends Classy {
  constructor(min, max) {
    super();
    // This will be the minimum value
    this.from = min;
    // This will be the maximum value
    this.to = max;
    // Create a holder element
    this.holder = document.createElement('div');
    // This will be a decoration element, it will be used to show the range between the min and max values
    this.range = document.createElement('div');
    // Create a label for the min input value
    this.fromLabel = document.createElement('span');
    // Create a label for the max input value
    this.toLabel = document.createElement('span');

    // The active input
    this.active = null;

    // Add the range class to the holder element
    this.holder.classList.add('range-slider');
    // Add the range class to the range element
    this.range.classList.add('range-slider__range');
    // Add the range class to the min label element
    this.fromLabel.classList.add('range-slider__label', 'range-slider__label--min');
    // Add the range class to the max label element
    this.toLabel.classList.add('range-slider__label', 'range-slider__label--max');

    // Set the min input element's max attribute to the max input element's max attribute
    this.from.max = this.to.max;
    // Set the max input element's min attribute to the min input element's min attribute
    this.to.min = this.from.min;

    // Set the min input element's value to 25% of the max input element's max attribute
    if (this.from.getAttribute('value') == null) this.from.value = this.from.max - (this.from.max - this.from.min) * 0.75;
    // Set the max input element's value to 75% of the max input element's max attribute
    if (this.to.getAttribute('value') == null) this.to.value = this.to.max - (this.to.max - this.to.min) * 0.25;

    // this.Observer = new MutationObserver(() => {
    //   this.change();
    //   console.log('change');
    // });

    // When either input changes value, call the change method
    [this.from, this.to].forEach(input => {
      // this.Observer.observe(input, {
      //   attributes: true,
      // });

      input.form.addEventListener('reset', () => {
        console.log('reset');
        setTimeout(() => {
          this.change();
        }, 10);
      });
      ['change', 'input'].forEach(event => {
        input.addEventListener(event, () => this.change());
      });
    });

    // When the user mouses over the holder, log the event x
    this.holder.addEventListener('mousemove', event => {
      // Get the clientX calculated as a value on the range slider between this.from.min and this.to.max
      let x = Math.round((event.clientX - this.holder.getBoundingClientRect().left) / this.holder.clientWidth * (this.to.max - this.from.min) + this.from.min);

      // If the x value is closest to the min input value, set the min input zIndex to 1 and the max input zIndex to 0 and vice versa
      if (x - (this.from.value - this.from.min) < this.to.value - this.to.min - x) {
        // If this input is not the active input, set it to the active input
        if (this.active != this.from) {
          this.from.style.zIndex = 1;
          this.to.style.zIndex = 0;
          this.active = this.from;
        }
        ;
      }
      if (x - (this.from.value - this.from.min) > this.to.value - this.to.min - x) {
        // If this input is not the active input, set it to the active input
        if (this.active != this.to) {
          this.from.style.zIndex = 0;
          this.to.style.zIndex = 1;
          this.active = this.to;
        }
        ;
      }
    });

    // Call the update
    this.update();
  }
  update() {
    // Set the min label's text to the min input value
    this.fromLabel.textContent = this.from.value;
    // Set the max label's text to the max input value
    this.toLabel.textContent = this.to.value;

    // Update the text content of each label to include , separators to make the numbers more readable
    [this.fromLabel, this.toLabel].forEach(label => {
      // If the label text is less than 4 characters long, return
      if (label.textContent.length <= 4) return;
      // Otherwise, replace the text content with the text content with , separators
      label.textContent = label.textContent.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });

    // Set the range element's style left to the min input value as a percentage
    this.range.style.left = `${(this.from.value - this.from.min) / (this.from.max - this.from.min) * 100}%`;
    // Set the range element's style right to the max input value as a percentage
    this.range.style.right = `${100 - (this.to.value - this.to.min) / (this.to.max - this.to.min) * 100}%`;
    let fromLabelLeft = (this.from.value - this.from.min) / (this.from.max - this.from.min) * 100;
    let toLabelLeft = (this.to.value - this.to.min) / (this.to.max - this.to.min) * 100;

    // let fromLabelRight = 100 - fromLabelLeft;
    let toLabelRight = 100 - toLabelLeft;

    // // Set the min label's style left to the min input value as a percentage
    this.fromLabel.style.left = `${fromLabelLeft}%`;
    // // Set the max label's style right to the max input value as a percentage
    this.toLabel.style.right = `${toLabelRight}%`;

    // As the toLabel decreases in value, translateX to the right
    this.fromLabel.style.transform = `translateX(-${fromLabelLeft}%)`;
    // As the fromLabel increases in value, translateX to the left
    this.toLabel.style.transform = `translateX(${toLabelRight}%)`;
  }

  // function to change a number to a min/max value
  clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }
  change() {
    const min = this.clamp(this.from.value, this.from.min, this.to.value);
    const max = this.clamp(this.to.value, this.from.value, this.to.max);
    this.from.value = min;
    this.to.value = max;

    // Update the styles
    this.update();

    // Call the callback
    this.callback('change', {
      min: this.from.value,
      max: this.to.value
    });
  }
  render() {
    // Append the min, max, and range etc elements to the holder element
    this.holder.appendChild(this.from);
    this.holder.appendChild(this.to);
    this.holder.appendChild(this.range);
    this.holder.appendChild(this.fromLabel);
    this.holder.appendChild(this.toLabel);

    // Return the holder element
    return this.holder;
  }
}